import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$1 from '../../ui/Skeleton.vue.js';

var script = defineComponent({
    name: 'TextBoxPicker',
    components: {
        ButtonComponent: __vue_component__,
        Skeleton: __vue_component__$1,
    },
    model: {
        prop: 'selectedItem',
        event: 'selectItem',
    },
    props: {
        /** Outline all buttons in red due to failed validation */
        highlight: Boolean,
        horizontal: Boolean,
        items: {
            type: Array,
            default: null,
        },
        selectedItem: {
            type: String,
            default: null,
        },
    },
    setup(props, { emit }) {
        const formattedItems = computed(() => {
            var _a, _b;
            return (_b = (_a = props.items) === null || _a === void 0 ? void 0 : _a.map((item) => {
                const isSelected = item.value === props.selectedItem;
                return {
                    ...item,
                    isSelected,
                    buttonStyle: isSelected ? 'primary' : 'outline-white',
                };
            })) !== null && _b !== void 0 ? _b : [];
        });
        const classNames = computed(() => {
            const names = [];
            if (props.horizontal)
                names.push('TextBoxPicker--horizontal');
            if (props.highlight)
                names.push('TextBoxPicker--highlight');
            return names;
        });
        const getButtonClassNames = (item) => item.isSelected ? ['TextBoxPicker__item--selected'] : [];
        const selectItem = (item) => {
            emit('selectItem', item.value);
        };
        return {
            classNames,
            formattedItems,
            getButtonClassNames,
            selectItem,
        };
    },
});

export { script as default };
